/* Sticky Add to Bag bar — phones only.

   Mirrors the real purchase controls; it never owns any of them. The button
   is a submit for #main-product-form, so the cart receives exactly the
   variant and quantity the real form holds. Everything visible here is
   copied FROM the live elements, so cart-drawer.js does not need to know
   this file exists — whatever it does to the price, the label or the
   disabled state simply shows up here too.

   Deliberately not a Liquid-rendered copy of the buy row: a second control
   holding its own variant is how a shopper ends up receiving a size they
   did not choose. */
(function () {
  "use strict";

  var bar = document.querySelector("[data-sticky-atb]");
  if (!bar) return;

  var realBtn = document.querySelector("[data-add-to-cart]");
  var realLabel = document.querySelector("[data-add-to-cart-label]");
  var realPrice = document.querySelector("[data-product-price]");
  if (!realBtn) return;

  var barBtn = bar.querySelector("[data-sticky-atb-btn]");
  var barLabel = bar.querySelector("[data-sticky-atb-label]");
  var barPrice = bar.querySelector("[data-sticky-atb-price]");
  var barMeta = bar.querySelector("[data-sticky-atb-meta]");

  /* ---- Mirror the real controls -------------------------------------- */

  function syncFromReal() {
    if (realPrice && barPrice) barPrice.textContent = realPrice.textContent.trim();
    if (realLabel && barLabel) barLabel.textContent = realLabel.textContent.trim();
    barBtn.disabled = realBtn.disabled;

    /* The chosen options, read off whichever buttons are currently active.
       .is-active is what snippets/featured-product-option.liquid marks the
       selected value with, for both the color swatches and the size
       buttons. Reading the DOM rather than re-deriving from the product
       JSON means there is one source of truth, and it is the same one the
       shopper is looking at. */
    if (!barMeta) return;
    var chosen = [];
    document.querySelectorAll("[data-option-value].is-active").forEach(function (el) {
      var v = el.getAttribute("data-value");
      if (v) chosen.push(v);
    });
    barMeta.textContent = chosen.join(" · ");
  }

  syncFromReal();

  /* cart-drawer.js rewrites these nodes on every variant change and does
     not emit an event, so watch them instead of asking it to. Cheap: three
     small subtrees, and only while a PDP is open. */
  var mo = new MutationObserver(syncFromReal);
  var moOpts = { childList: true, characterData: true, subtree: true, attributes: true };
  if (realPrice) mo.observe(realPrice, moOpts);
  if (realLabel) mo.observe(realLabel, moOpts);
  mo.observe(realBtn, { attributes: true, attributeFilter: ["disabled"] });
  document.querySelectorAll("[data-option-value]").forEach(function (el) {
    mo.observe(el, { attributes: true, attributeFilter: ["class"] });
  });

  /* ---- Show it only once the real button has gone ---------------------- */

  var offscreen = false;

  function render() {
    /* Never on top of a full-surface overlay. The cart drawer and the
       mobile menu both cover the page, and a floating buy button over
       either is a mis-tap waiting to happen. */
    var drawer = document.querySelector("[data-cart-drawer]");
    var panel = document.querySelector("[data-mobile-panel]");
    var blocked =
      (drawer && drawer.classList.contains("is-open")) ||
      (panel && panel.classList.contains("is-open"));

    var show = offscreen && !blocked;
    bar.classList.toggle("is-visible", show);
    bar.setAttribute("aria-hidden", show ? "false" : "true");
    /* Focusable only when visible, so keyboard tab order never lands on an
       invisible duplicate of a button that is already on the page. */
    barBtn.setAttribute("tabindex", show ? "0" : "-1");
  }

  if ("IntersectionObserver" in window) {
    new IntersectionObserver(
      function (entries) {
        offscreen = !entries[0].isIntersecting;
        render();
      },
      { rootMargin: "0px 0px -40px 0px" }
    ).observe(realBtn);
  } else {
    /* No IO: fall back to showing it past a screenful. Worse, but never
       worse than not having the bar at all. */
    window.addEventListener(
      "scroll",
      function () {
        offscreen = window.scrollY > window.innerHeight;
        render();
      },
      { passive: true }
    );
  }

  /* Overlays toggle a class with no event of their own. */
  var overlayWatch = new MutationObserver(render);
  ["[data-cart-drawer]", "[data-mobile-panel]"].forEach(function (sel) {
    var el = document.querySelector(sel);
    if (el) overlayWatch.observe(el, { attributes: true, attributeFilter: ["class"] });
  });

  /* ---- Stay clear of the cookie banner --------------------------------
     The consent banner is position:fixed at
     bottom: max(14px, env(safe-area-inset-bottom)) with a z-index near the
     top of the range, and it is a legal control -- this bar must not cover
     it or sit under it. Measure it and lift out of the way for as long as
     it is there. Nothing to do once consent is given: the banner leaves the
     DOM and the offset returns to zero.

     This is the collision that would otherwise only show up on a first
     visit, which is exactly the visit that matters. */
  function offsetForConsent() {
    var banner = document.getElementById("shopify-pc__banner");
    var offset = 0;
    if (banner) {
      var r = banner.getBoundingClientRect();
      if (r.height > 0 && r.bottom > window.innerHeight - r.height - 60) {
        offset = Math.round(r.height + 10);
      }
    }
    bar.style.setProperty("--atb-consent-offset", offset + "px");
  }

  offsetForConsent();
  window.addEventListener("resize", offsetForConsent, { passive: true });
  /* The banner is injected asynchronously by Shopify and revealed on a
     delay by consent-delay.js, so a single measurement at load is not
     enough. */
  new MutationObserver(offsetForConsent).observe(document.body, {
    childList: true,
    subtree: false
  });
  window.setTimeout(offsetForConsent, 1200);
  window.setTimeout(offsetForConsent, 6000);
})();
